import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsTypeaheadComponent,
  WmsToggleComponent,
  WmsDialogComponent,
  WmsDialogHeaderComponent,
  WmsDialogBodyComponent, WmsDialogFooterComponent
} from '@wms/components';
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { WmsCriteriaBuilderComponent } from '@wms/app/filter-criteria';
import { FormsModule } from '@angular/forms';
import { getMatchModes } from '@wms/core';
import { CheckboxsetComponent, WMSOrderbyComponent } from '@wms/properties-panel';
import {forEach, includes, isArray, set, sortBy, upperCase} from 'lodash-es';
import { OrderByPipe } from '@wm/components-base';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { getVariableByName } from "@wms/variables";
import { Subscription } from 'rxjs';
import {runtimeEventManager} from "@wm/core";
import {WidgetPropertiesProvider} from "@wms/app/design-container";

@Component({
  selector: 'wms-form-filter-basic',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsTypeaheadComponent,
    WmsCriteriaBuilderComponent,
    WmsToggleComponent,
    CheckboxsetComponent,
    WMSOrderbyComponent,
    OrderByPipe,
    TooltipModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsDialogComponent
  ],
  templateUrl: './form-filter-basic.component.html',
  styleUrls: ['./form-filter-basic.component.less']
})
export class FormFilterBasicComponent extends BaseComponent implements OnInit {

  liveWidgetSettingsService: LiveWidgetSettingsService;
  matchModes: any;
  toUpperCase = upperCase;
  widgetTypeOptions: any = [];
  otherWdgts: any = [];
  myWidgets: any = [];
  widgetTypeOptionsSubscription: Subscription;
  protected isPrism: boolean = false;

  constructor(private widgetPropertiesProvider: WidgetPropertiesProvider) {
    super();
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.matchModes = getMatchModes();
  }

  ngOnInit(): void {
    this.widgetTypeOptionsSubscription = this.liveWidgetSettingsService.widgetTypeOptionsObservable().subscribe(() => {
      this.widgetTypeOptions = sortBy(this.liveWidgetSettingsService.selectedComponent.field.widgetTypeOptions);
      this.otherWdgts = sortBy(this.liveWidgetSettingsService.otherWdgts);
      this.myWidgets = sortBy(this.widgetPropertiesProvider.getSubGroup('Mywidgets', 'custom-widgets').widgets, ['displayName']);
    });

    this.isPrism = this.projectService.isPrism();
    this.liveWidgetSettingsService.activeWidgetScope.variableObj = this.liveWidgetSettingsService.activeWidgetScope.Variables[this.liveWidgetSettingsService.variableName]
  }

  onWidgetTypeChange = (field: any) => {
    // On widget change, save only properties specific to form field. Reset widget specific properties.
    let saveProps = ['name', 'displayname', 'show', 'primaryKey', 'generator', 'period', 'key', 'type', 'widget', 'isRelated', 'field',
      'isRange', 'matchmode', 'mobileDisplay', 'pcDisplay', 'tabletDisplay', 'relatedEntityName', 'lookupType', 'lookupField', 'isPrimaryKey',
      'ngClasses', 'widgetTypeOptions', 'displaywidget', 'widgetid', 'fieldDefConfig', 'widgettype', 'lookupFieldOptions', 'lookupTypeOptions'];
    if (this.liveWidgetSettingsService.designerType === this.liveWidgetSettingsService.designerTypes.LIVEFORM || this.liveWidgetSettingsService.designerType === this.liveWidgetSettingsService.designerTypes.LIVEFILTER
      || this.liveWidgetSettingsService.designerType === this.liveWidgetSettingsService.designerTypes.FORM) {
      forEach(field, (val: any, key: any) => {
        if (!includes(saveProps, key)) {
          field[key] = undefined;
        }
      });
      if (field.isRange && this.liveWidgetSettingsService.hideRange[field.displaywidget]) {
        field.isRange = false; //Set range to false for widgets which does not support range
      }
    }
    if (field.displaywidget === 'text') {
      field.inputtype = undefined;
    }
  };

  getVariableDetails() {
    return getVariableByName(this.liveWidgetSettingsService.variableName);
  }

  onSaveClose(id: string) {
    runtimeEventManager.emit('savecloseCriteriaDialog', id);
  }

  onCancel(id: string) {
    runtimeEventManager.emit('closeCriteriaDialog', id);
  }

  handelChangesSearchKey(val: any) {
    this.liveWidgetSettingsService.selectedComponent.field.searchkey = isArray(val)? val.join(): val;
  }

  toToggle(property:string,event:any){
    set(this.liveWidgetSettingsService.selectedComponent.field,property,event);
    if(this.liveWidgetSettingsService.selectedComponent.field?.widgetProps?.maxplaceholder){
        this.liveWidgetSettingsService.selectedComponent.field.widgetProps.maxplaceholder.show=event;
    }
  }

  override ngOnDestroy(): void {
    if (this.widgetTypeOptionsSubscription) {
      this.widgetTypeOptionsSubscription.unsubscribe();
    }
  }
}
